import { gql, useQuery } from '@apollo/client';
import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import Button from '~Components/Button';
import Modal from '~ComponentsImproved/Modal';
import { useI18n, useSelector } from '~Hooks';

const Wrapper = styled.div`
  background-color: #fff;
  padding: 20px 28px;
  width: 450px;
  border-radius: 8px;
  text-align: center;
  position: relative;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
`;

const PromptText = styled.p`
  font-size: 16px;
  margin: 35px 0px;
`;

const COMPANY_QUERY = gql`
  query getCompany($companyId: ID!) {
    company: Company(id: $companyId) {
      id
      showPaymentPrompts
      country
      isPaymentsOnly
    }
  }
`;

export const PaymentReminder = () => {
  const companyId = useSelector((state) => state.company!);
  const { i18n } = useI18n();

  const { data: companyData } = useQuery(COMPANY_QUERY, {
    variables: { companyId: companyId },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  const [showing, setShowing] = useState(false);

  useEffect(() => {
    if (companyData?.company?.showPaymentPrompts) {
      setShowing(true);
    }
  }, [companyData?.company?.showPaymentPrompts]);

  return (
    <Modal isShowing={showing} backdropClose={false}>
      <Wrapper>
        <Title>{i18n('License.Unpaid.Title')}</Title>
        <PromptText>{i18n('License.Unpaid.Subtitle')}</PromptText>
        <Button
          handleClick={() => setShowing(false)}
          background={'var(--colorUIBlue)'}
          text={i18n('Adyen.Close')}></Button>
      </Wrapper>
    </Modal>
  );
};
